'use client'

import { Box, Flex, VStack, Text, HStack, Container, Stack, Link, Image } from "@chakra-ui/react";
import CommonContainer from "@/components/common/CommonContainer";
import { Logo } from "@/components/ui/svgs/logo";
import { DiscordIcon } from "@/components/ui/svgs/discordIcon";
import { TelegramIcon } from "@/components/ui/svgs/telegramIcon";
import { XIcon } from "@/components/ui/svgs/xIcon";
import { MEDIA_KIT_URL, WILDMETA_DISCORD_URL, WILDMETA_TELEGRAM_URL, WILDMETA_TWITTER_URL } from "@/lib/config/links";
import { CopyrightIcon } from "@/components/ui/svgs/copyrightIcon";

export default function FooterMobile() {
  return (
    <Box py={6} px={4} position="relative" zIndex={1} borderTop="1px solid rgba(255, 255, 255, 0.10)">
      <HStack mb={6}>
        <Logo width={28} fontSize={14} disableJump />
      </HStack>

      <Image src="/images/marketplace/footer-trade-smart.png" h="0.75rem" mb={8} />

      <HStack mb={4} gap="6" align="center">
        <Link href={MEDIA_KIT_URL}  target="_blank" _hover={{ opacity: 0.7 }}>
          <Image src="/images/marketplace/footer-marketkit.png" h="0.75rem" />
         </Link> 
        {/* Social Icons - Replace with actual icon components */}
        <Link href={WILDMETA_DISCORD_URL} target="_blank">
          <Stack w={8} h={8} justify="center" align="center" _hover={{ opacity: 0.7 }}>
            <DiscordIcon size={8} />
          </Stack>
        </Link>
        <Link href={WILDMETA_TELEGRAM_URL} target="_blank">
          <Stack w={8} h={8} justify="center" align="center" _hover={{ opacity: 0.7 }}>
            <TelegramIcon size={8} />
          </Stack>
        </Link>
      
        <Link href={WILDMETA_TWITTER_URL} target="_blank">
          <Stack w={8} h={8} justify="center" align="center" _hover={{ opacity: 0.7 }}>
            <XIcon size={8} />
          </Stack>
        </Link>
      </HStack>
      
      <HStack gap="1" align="center">
        <Text fontSize="xs" color="#8a8f98">Copyright</Text>
        <CopyrightIcon />
        <Text fontSize="xs" color="#8a8f98">© 2025 Wildmeta.</Text>
      </HStack>
    </Box>
  )
}